<template>
    <div class="Seguro-Colectivo-Salud">
        <div class="title">
            <span>Seguros</span>
            <h1>Empresariales</h1>
            <div id="contactForm">
                <label for="">Conoce más sobre soluciones de seguros</label>
                <div id="hubcontactForm"></div>
            </div>
        </div>
        <div class="info">
            <h1>Seguro de Cumplimiento para Contratistas y Proveedores</h1>
            <p>Su empresa necesita aliados que le generen confianza para llevar a cabo su actividad productiva. Ante el incumplimiento de
            contratistas y proveedores, respalde los compromisos que establezca con ellos.
            </p>
        </div>
        <div class="services">
            <center>
                <h1>Con este seguro de cumplimiento su empresa puede:</h1>
                <div v-for="(slide, i) in slides" :key="i">
                    <div v-for="(service, y) in slide.service" :key="y">
                        <div class="service-img">
                            <div>
                                <img :src="service.img" alt="">
                                <p v-html="service.text"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>Para cualquier empresa es un reto elegir a los contratistas y proveedores que la acompañarán en el desarrollo de un proyecto. Aunque
                estas decisiones se toman a partir de numerosas variables con el fin de evitar dificultades, siempre hay un nivel de incertidumbre que es
                esencial gestionar.
                <br>
                <br>
                Nada como contar con apoyo económico si un proveedor hizo mal uso de los recursos que su organización le dio para ejecutar una iniciativa,
                o si el producto o servicio que este le entregó resultó con fallas después de que fue recibido a satisfacción.
                <br>
                El Seguro de Cumplimiento para Contratistas y Proveedores le garantiza a su empresa el cuidado del patrimonio que ha construido en el
                tiempo por medio de un respaldo sólido ante el incumplimiento por parte de sus aliados.
                <br>
                <br>
                Con nosotros a su lado, la inquietud por el trabajo de un contratista o proveedor es cosa del pasado. Nos encargamos de esto para que
                fomente el progreso de su negocio. Recuerde: cualquier proyecto debe representar satisfacción para su empresa, no
                preocupaciones. <span>¡Permítanos asesorarlo!</span>
                </p>
            </center>
        </div>
        <div class="cobertura-principal">
            <center><h1>¿Qué cubrimos?</h1></center>
            <div>
                <center><img src="@/assets/Seguro-contrastistas-proveedores/4.png" alt=""></center>
                <div>
                    <div>
                        <img src="@/assets/Empresarial-Fraude-Empleados/Icon-mano.svg" alt="">
                        <label for="">Para daños materiales</label>
                    </div>
                    <p>
                    Asumimos los perjuicios asociados al daño emergente que sufra su empresa durante el proceso de selección de sus contratistas o
                    proveedores cuando:
                    <br>
                    <br>
                    <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                    Retire su propuesta sin justa causa después de finalizado el proceso.
                    <br>
                    <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                    No firme el contrato una vez salga favorecido en el proceso de selección.
                    <br>
                    <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                    No entregue el seguro de cumplimiento, que es un requisito para la firma del contrato.
                    <br>
                    <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                    No modifique la garantía de seriedad de la oferta cuando el proceso de selección se extienda por otro periodo.
                    </p>
                </div>
            </div>
        </div>
        <div class="slide-cobertura-opcional">
            <center><h1>Coberturas opcionales</h1></center>
            <VueSlickCarousel
            class="slider"
            ref="slick"
            :autoplay="true"
            :dots="true"
            :arrows="false">
                <div v-for="(slide, i) in coberturaOpcional" :key="i">
                    <div class="cobertura-principal-slide">
                        <div>
                            <img src="@/assets/Empresarial-Fraude-Empleados/Icon-mano.svg" alt="">
                            <label for="">{{slide.label}}</label>
                        </div>
                       <p v-html="slide.p"></p>
                    </div>
                </div>
            </VueSlickCarousel>
        </div>
        <div class="opcionales">
            <center>
                <h1>¿Qué no cubrimos?</h1>
                <p><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                Los eventos constitutivos de causa extraña, esto es, fuerza mayor o caso fortuito, involucramiento de un tercero, culpa exclusiva de
                la víctima y    cualquier otro hecho que de acuerdo con la ley o el contrato exoneren al contratista u oferente.</p>
                <p><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                Las sanciones, cláusulas penales o multas impuestas al contratista.</p>
                <p><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                Cualquier daño causado a terceros.</p>
                <p><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                Las indemnizaciones por accidente de trabajo o enfermedad profesional del personal a cargo del contratista y que esté vinculado
                con la ejecución del contrato.</p>
                <p><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>
                Lucro cesante (pérdida de ganancia o utilidad económica por afectaciones relacionadas con este seguro).</p>
            </center>
        </div>
        <div class="connect">
            <img src="@/assets/bg-llamado-accion.webp" alt="">
            <h1>¿Qué empresas se pueden asegurar?</h1>
            <p>Todas las que deben contratar los servicios de contratistas y proveedores para el desarrollo de sus proyectos y actividades.</p>
        </div>
        <div class="move"><center><img src="@/assets/Todo-riesgo-empresarial/4.png" alt=""></center></div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'
import VueSlickCarousel from 'vue-slick-carousel'

export default {
    name: 'Seguro-Colectivo-salud',
    metaInfo() {
        return {
            title: 'Seguro colectivo de salud',
            titleTemplate: '%s | Interseguros',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: 'Ofrecerle a sus empleados la oportunidad de acceder a un seguro de salud complementario al Plan Obligatorio, es un beneficio más que puede incluir en su empresa, al darles la posibilidad de contar con servicios de alta calidad a un mejor precio.'
            },
            {
                vmid: 'keywords',
                name: 'keywords',
                content: 'Asesor en riesgos laborales, intermediación ARL, Control de ARL, Seguros ARL, Administradora de Riesgo Laborales, Seguros Generales, Seguros Empresariales, Seguros Personales'
            },
            {
                vmid: 'image',
                name: 'image',
                content: require('@/assets/logo/logo.webp')
            },
            {
                vmid: 'robots',
                name: 'robots',
                content: 'index, follow'
            },
            {
                vmid: 'twitter:card',
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                vmid: 'twitter:title',
                name: 'twitter:title',
                content: 'Interseguros'
            },
            {
                vmid: 'twitter:site',
                name: 'twitter:site',
                content: '@Interseguros'
            },
            {
                vmid: 'twitter:description',
                name: 'twitter:description',
                content: 'Recibe asesoría para cotizar y contratar diferentes tipos de seguros para empresas.'
            },
            {
                vmid: 'twitter:image',
                name: 'twitter:image',
                content: require('@/assets/image-people.png')
            }]
        }
    },
    components: {
        Aliados,
        VueSlickCarousel
    },
    data() {
        return {
            slides: [
                {
                    service: [
                        {
                            text: 'Respaldar los proyectos que tiene estimado desarrollar para su óptima ejecución.',
                            img: require('@/assets/Seguro-contrastistas-proveedores/1.png')
                        },
                        {
                            text: 'Asegurar el cumplimiento de las obligaciones que el contratista o proveedor tiene con su organización.',
                            img: require('@/assets/Seguro-contrastistas-proveedores/2.png')
                        },
                        {
                            text: 'Cuidar los esfuerzos y el patrimonio de su empresa.',
                            img: require('@/assets/Seguro-contrastistas-proveedores/3.png')
                        }
                    ]
                }
            ],
            coberturaOpcional: [
                {
                    label: 'Pago anticipado',
                    p: 'Pagamos el valor del daño emergente que el contratista cause a su negocio por la no devolución del pago anticipado que usted le entregó cuando este no haya cumplido con su obligación.'
                },
                {
                    label: 'Buen manejo, correcta inversión, amortización y devolución del anticipo',
                    p: 'Respaldamos los pagos que le anticipe al contratista en caso de que este no los haya invertido correctamente en la ejecución del contrato.'
                },
                {
                    label: 'Cumplimiento',
                    p: 'Garantizamos el cumplimiento del contrato e indemnizamos los perjuicios que el contratista le cause a su empresa.'
                },
                {
                    label: 'Pago de salarios, prestaciones sociales e indemnizaciones laborales',
                    p: 'Respaldamos el pago de salarios, prestaciones sociales e indemnizaciones laborales que el contratista incumpla con el personal que ejecuta el proyecto, siempre y cuando su negocio sea solidariamente responsable.'
                },
                {
                    label: 'Estabilidad de la obra',
                    p: 'Respondemos por el daño emergente que se produzca debido al deterioro del producto o servicio entregado por el contratista, sea por un vicio oculto u otro factor. Dicho producto o servicio debe: <br><br> <span>• Estar en condiciones normales de uso al momento de sufrir el daño.</span><br> <span>• Haber sido recibido a total satisfacción.</span><br> <span>• No poder cumplir la finalidad para la cual se realizó.</span>'
                },
                {
                    label: 'Calidad del bien o servicio',
                    p: 'Lo apoyamos en caso de una deficiente calidad de los bienes suministrados o del servicio prestado por el contratista de acuerdo con las especificaciones y los requisitos nombrados en el contrato y las condiciones de calidad e idoneidad establecidas en el estatuto del consumidor u otras normas técnicas.'
                },
                {
                    label: 'Buen manejo de materiales y equipos',
                    p: 'Si el contratista no le devuelve materiales y equipos que su negocio le facilitó para la ejecución del contrato firmado, o se los regresa con fallas y averías, le pagaremos el daño emergente que esto le cause.'
                },
                {
                    label: 'Provisión de repuestos y accesorios',
                    p: 'Si el contratista no le provee los repuestos y accesorios descritos en el contrato, le pagaremos el daño emergente que esto le genere a su empresa.'
                }
            ],
            slickOptionsExperiencies: {
                'dots': false,
                'arrows': true,
                'focusOnSelect': true,
                'infinite': true,
                'speed': 500,
                'autoplay': true,
                'autoplaySpeed': 3000,
                'slidesToShow': 3,
                'slidesToScroll': 3,
                'touchThreshold': 5,
                'responsive': [
                    {
                        'breakpoint': 1140,
                        'settings': {
                            'slidesToShow': 2,
                            'slidesToScroll': 2,
                            'infinite': true
                        }
                    },
                    {
                        'breakpoint': 680,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1,
                            'infinite': true
                        }
                    }
                ]
            },
            especialidades: [
                {
                    image: require('@/assets/Todo-riesgo-empresarial/1.png'),
                    texto: 'Recuperar los bienes muebles e inmuebles que su empresa pierda en un evento cubierto por el seguro.'
                },
                {
                    image: require('@/assets/Todo-riesgo-empresarial/2.png'),
                    texto: 'Contar con respaldo para enfrentar dificultades legales, afectaciones a terceros, fraude de empleados, entre otras situaciones.'
                },
                {
                    image: require('@/assets/Todo-riesgo-empresarial/3.png'),
                    texto: 'Tener asistencia especializada para reparar daños en su empresa y atender emergencias.'
                },
                {
                    image: require('@/assets/Todo-riesgo-empresarial/1.png'),
                    texto: 'Asegurar la continuidad de sus actividades productivas por medio de la gestión responsable de los riesgos.'
                }
            ]
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>
<style>
    .cobertura-principal-slide > p > span {
        font-weight: bold;
        margin-left: 5em;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 25px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 5px;
        margin-bottom: 15px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
</style>

<style scoped>
    .title {
        background-image: url('../../../assets/servicios-empresariales-bg.png');
        padding: 200px 300px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
    }
    .title > span {
        font-family: 'JLI';
        font-size: 40px;
    }
    .title > h1 {
        font-family: 'JBD';
        font-size: 50px;
    }
    #contactForm {
        margin-top: -100px;
        font-family: 'JR';
        background-color: #fff;
        padding: 40px;
        position: absolute;
        border-radius: 10px;
        width: 400px;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        font-weight: bolder;
        right: 100px;
    }
    #contactForm > label {
        color: #65b24a;
        font-size: 24px;
        line-height: 25px;
    }
    .info {
        padding: 100px 0px;
    }
    .info > h1 {
        font-family: 'JBD';
        color: #65b24a;
        padding-left: 300px;
        font-size: 40px;
        width: 60%;
    }
    .info > p {
        font-family: 'JR';
        width: 60%;
        padding-left: 300px;
        margin-top: 10px;
        font-size: 18px;
    }
    .services {
        padding: 50px 300px;
        width: 100%;
    }
    .services > center {
        display: contents;
    }
    .services > center > div {
        display: inline-block;
        width: 100%;
    }
    .services > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 50px;
        font-size: 30px;
    }
    .services > center > div > div {
        display: inline-flex;
        width: 33.333333333%;
        float: left;
    }
    .services > center > div > div > .service-img {
        width: 100%;
    }
    .services > center > div > div > .service-img > div {
        position: relative;
        width: 100%;
        height: 100%;
        padding: auto;
        margin-bottom: 10px;
        transition: margin-top .5s ease-out 100ms;
    }
    .services > center > div > div > .service-img > div:hover {
        margin-top: -10px;
    }
    .services > center > div > div > .service-img > div >  img {
        width: 100%;
        height: auto;
    }
    .services > center > div > div > .service-img > div >  p {
        font-family: 'JR';
        font-size: 18px;
    }
    .texto {
        width: 100%;
        padding: 10px 300px;
    }
    .texto > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box-title {
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .texto > .box-title > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box {
        padding: 20px 20px;
        text-align: left;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        margin-bottom: 10px;
    }
    .texto > center > p {
        font-family: 'JR';
    }
    .texto > center > p > span{
        font-weight: bold;
    }
    .service {
        padding: 20px 300px;
        width: 100%;
    }
    .service > div {
        width: 100%;
        margin-top: 20px;
    }
    .service > div {
        width: 100%;
        display: flex;
    }
    .service > div > div > img {
        width: 350px;
        float: left;
    }
    .service > div > .imgbox {
        display: block;
        width: 350px;
        z-index: 99999;
    }
    .service > div > .box {
        margin-left: -300px;
        margin-top: 110px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 30px 30px 350px;
    }
    .service > div > .box2 {
        margin-right: -300px;
        margin-top: 60px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 350px 100px 30px;
    }
    .service > div > .right{
        position: absolute;
        right: 15%;
    }
    .service > div > .box > h1 {
        position: relative;
        font-family: 'JBD';
        color:#2d4f98;
        margin-top: -120px;
        margin-bottom: 60px;
        text-align: left;
    }
    .service > div > .box > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .service > div > .box2 > h1 {
        position: relative;
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 10px;
        margin-top: -120px;
        text-align: right;
        margin-bottom: 60px;
    }
    .service > div > .box2 > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .facirclecheck-service {
        margin-right: 4px;
        margin-top: 4px;
        font-weight: bolder;
        color: #2d4f98;
        width: 15px;
        height: 15px;
        float: left;
    }
    .cobertura-principal {
        width: 100%;
        padding: 0px 300px;
    }
    .cobertura-principal > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
    }
    .cobertura-principal > div {
        display: flex;
        margin-bottom: 50px;
    }
    .cobertura-principal > div > center > img {
        width: 200px;
        height: auto;
    }
    .cobertura-principal > div > div {
        padding: 20px;
    }
    .cobertura-principal > div > div > div > img{
        width: 50px;
        margin-right: 20px;
    }
    .cobertura-principal > div > div > div > label{
        font-family: 'JBD';
        color: #65b24a;
        font-size: 20px;
    }
    .cobertura-principal > div > div > p{
        padding: 25px;
        margin-top: 20px;
        font-family: 'JR';
        -webkit-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        -moz-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
    }
    .cobertura-principal-slide{
        padding: 0px 300px;
    }
    .cobertura-principal-slide > div {
        display: flex;
    }
    .cobertura-principal-slide > div > label {
        color: #65b24a;
        font-family: 'JBD';
        font-size: 20px;
    }
    .cobertura-principal-slide > div > img {
        width: 50px;
    }
    .cobertura-principal-slide > p {
        font-family: 'JR';
        margin-top: 10px;
        margin-bottom: 60px;
    }
    .slide-cobertura-opcional > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .opcionales {
        padding: 50px 300px;
        font-family: 'JR';
    }
    .opcionales > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-bottom: 20px;
    }
    .opcionales > center > p {
        text-align: left;
    }
    .opcionales > .opcional > .subopcional {
        padding-left: 50px;
    }
    .connect {
        background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
        background: linear-gradient(to right, #2d4f98 30%, #65b24a);
        height: 200px;
        width: 100%;
    }
    .connect > img {
        position: absolute;
        height: 200px;
        width: 380px;
        right: 0;
        object-fit: cover;
        object-position: 75px -70px;
    }
    .connect > h1 {
        font-family: 'JBD';
        padding-top: 50px;
        padding-left: 200px;
        color: #65b24a;
    }
    .connect > p{
        font-family: 'JR';
        padding-left: 200px;
        width: 80%;
        color: #fff;
        font-size: 22px;
        line-height: 25px;
    }
    .move > center > img {
        margin-top: 30px;
        width: 800px;
    }
    @media (max-width: 1600px) {
        .slider2 {
            width: 60%;
        }
    }
    @media (max-width: 1500px) {
        .title {
            padding: 200px 200px;
        }
        .info > h1 {
            padding-left: 200px;
        }
        .info > p {
            padding-left: 200px;
        }
        .slider2 {
            width: 65%;
        }
        .services {
            padding: 50px 200px;
            width: 100%;
        }
    }
    @media (max-width: 1400px) {
        .title {
            padding: 200px 100px;
        }
        .info > h1 {
            padding-left: 100px;
        }
        .info > p {
            padding-left: 100px;
        }
        .services {
            padding: 50px 100px;
            width: 100%;
        }
        .service {
            padding: 20px 150px;
            width: 100%;
        }
        .slider2 {
            width: 70%;
        }
    }
    @media (max-width: 1300px) {
        .info > h1 {
            font-size: 30px;
        }
        .info > p {
            width: 50%;
        }
        .texto {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal-slide{
            padding: 0px 200px;
        }
        .services {
            padding: 50px 50px;
            width: 100%;
        }
        .opcionales {
            padding: 50px 200px;
        }
        .slider2 {
            width: 75%;
        }
    }
    @media (max-width: 1200px) {
        .service {
            padding: 20px 75px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 10%;
        }
    }
    @media (max-width: 1100px) {
        .service {
            padding: 20px 50px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 5%;
        }
        .connect > h1 {
            padding-top: 10px;
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        .connect > p{
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        #contactForm {
            margin-top: -100px;
            right: 50px;
        }
        .slider2 {
            width: 80%;
        }
    }
    @media (max-width: 1000px) {
        .title {
            padding: 50px 0px;
            height: 400px;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .info {
            padding-top: 400px;
            width: 100%;
            text-align: center;
        }
        .info > h1 {
            padding: 10px;
        }
        .info > p {
            width: 100%;
            text-align: center;
            padding: 10px;
        }
        .texto {
            width: 100%;
            padding: 10px 100px;
        }
        .services {
            padding: 0px 50px;
        }
        .service {
            padding: 20px 25px;
            width: 100%;
        }
        .connect > h1 {
            padding-left: 50px;
            font-size: 30px;
        }
        .connect > p{
            padding-left: 50px;
            font-size: 18px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 100px;
        }
        .cobertura-principal-slide{
            padding: 0px 100px;
        }
        .opcionales {
            padding: 50px 100px;
        }
    }
    @media (max-width: 900px) {
        .colectivo > center > div {
            display: block;
        }
        .move > center > img {
            width: 700px;
        }
    }
    @media (max-width: 800px) {
        .services > center > div > div {
            display: block;
            width: 60%;
            float: none;
        }
        .service > div {
            display: grid;
        }
        .service > div > .box{
            margin-left: 0px;
            margin-top: 0px;
            width: 100%;
            padding: 30px 30px 30px 30px;
        }
        .service > div > .box2 {
            margin-right: 0px;
            margin-top: 0px;
            background-color: #fff;
            width: 100%;
            padding: 30px 30px 100px 30px;
        }
        .service > div > .imgbox {
            display: block;
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .service > div > .imgbox > img{
            width: 250px;
            margin: auto;
        }
        .service > div > .right{
            position: relative;
            right: 0px;
        }
        .service > div > .box2 > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .service > div > .box > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .cobertura-principal > div {
            display: block;
        }
        .move > center > img {
            width: 600px;
        }
    }
    @media (max-width: 700px) {
        .texto {
            width: 100%;
            padding: 10px 50px;
        }
        .cobertura-principal {
            padding: 10px 50px;
        }
        .cobertura-principal-slide {
            padding: 0px 50px;
        }
        .opcionales {
            padding: 50px 50px;
        }
        .move > center > img {
            width: 500px;
        }
    }
    @media (max-width: 600px) {
        .connect > h1 {
            font-size: 18px;
        }
        .connect > p{
            font-size: 18px;
            width: 100%;
        }
        .services > center > div > div {
            width: 70%;
        }
        .move > center > img {
            width: 400px;
        }
    }
    @media (max-width: 500px) {
        .texto > .box-title > h1 {
            font-size: 30px;
        }
        #contactForm {
            width: 300px;
        }
        .connect > h1 {
            padding-left: 25px;
        }
        .connect > p{
            padding-left: 25px;
        }
        .services > center > div > div {
            width: 80%;
        }
        .slide-cobertura-opcional > center > h1 {
            font-size: 30px;
        }
        .cobertura-principal > center > h1{
            font-size: 30px;
        }
        .opcionales > center > h1 {
            font-size: 30px;
        }
        .move > center > img {
            width: 300px;
        }
    }
    @media (max-width: 400px) {
        .services > center > div > div {
            width: 90%;
        }
        .connect > p{
            padding-left: 5px;
            font-size: 16px;
            line-height: 19px;
        }
        .move > center > img {
            width: 250px;
        }
        .especial img {
            width: 240px;
        }
        .cobertura-principal > div > div {
            padding: 20px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosEmpresas/CumplimientoConstratistasProveedores.vue